import OciSlice from './oci.slice';

export const { actions: oci_actions } = OciSlice;

export default OciSlice.reducer;
